import React from 'react'
import Link from '../helper/link'

import TimeRange from '../app/timeRange'
import { MonitorOperation } from '../domain/Operation'
import Bottlenecks from '../helper/bottlenecks'
import LargeNumber from '../helper/large-number'
import Milliseconds from '../helper/milliseconds'
import Shorten from '../helper/shorten'
import Sparkline, { SparklineDataPoint } from '../helper/sparkline'
import Tendency from '../helper/tendency'
import TracepointIndicator from './operation/tracepoint-indicator'

interface Props {
    operation: MonitorOperation
    sparkline: SparklineDataPoint[]
    range: TimeRange
    route: string
    parameters: { [key: string]: string }
    loading: boolean
    full: boolean
    compact: boolean
}
class ExternalOperation extends React.Component<Props> {
    public static defaultProps = {
        range: null,
        sparkline: null,
        route: 'XhprofProfilerBundle.Transaction.show',
        parameters: {},
        loading: false,
        full: false,
        compact: false,
    }

    public render() {
        let icon = null
        if (this.props.operation.change) {
            const iconMap = {
                new: 'fa fa-plus-circle',
                up: 'fa fa-chevron-circle-up',
                down: 'fa fa-chevron-circle-down',
                same: 'fa fa-circle-o',
            }
            icon = iconMap[this.props.operation.change]
        }

        let parameters = {
            ...this.props.parameters,
            operation: this.props.operation.id,
        }

        if (this.props.range) {
            parameters = {
                ...parameters,
                ...this.props.range.toParameters(),
            }
        }

        const externalCallIdentifier = this.props.operation.identifier || this.props.operation.name
        const externalCallName = (
            <React.Fragment>
                {icon ? <span className={icon} /> : null}
                {this.props.operation.bottlenecks ? (
                    <Bottlenecks bottlenecks={this.props.operation.bottlenecks} bottleneckTypes={[]} />
                ) : null}
                <Shorten string={externalCallIdentifier} />
                {this.props.full && this.props.operation.name !== externalCallIdentifier ? (
                    <div className="small text-mute">{this.props.operation.name}</div>
                ) : null}
                <TracepointIndicator operation={this.props.operation} />
            </React.Fragment>
        )

        return (
            <tr>
                <td>
                    {this.props.route ? (
                        <Link title={this.props.operation.name} route={this.props.route} params={parameters}>
                            {externalCallName}
                        </Link>
                    ) : (
                        externalCallName
                    )}

                    {!this.props.operation.prioritized ? null : (
                        <small>
                            <span className="label label-burning" style={{ marginLeft: '1em' }}>
                                <i className="fa fa-rocket" /> prioritized
                            </span>
                        </small>
                    )}
                </td>

                {!this.props.operation.requests ? null : (
                    <React.Fragment>
                        <td className="number">
                            <LargeNumber value={this.props.operation.requests} />{' '}
                            {this.props.operation.requestsChange !== null ? (
                                <Tendency value={this.props.operation.requestsChange / 100} showValue={false} lessIsGood={false} />
                            ) : null}
                        </td>
                        {this.props.compact ? null : (
                            <td className="number">
                                <Milliseconds value={this.props.operation.averageResponse * 1000} />{' '}
                                {this.props.operation.averageResponseChange !== null ? (
                                    <Tendency value={this.props.operation.averageResponseChange / 100} showValue={false} />
                                ) : null}
                            </td>
                        )}
                        <td className="number">
                            <Milliseconds value={this.props.operation.maxResponse * 1000} />{' '}
                            {this.props.operation.maxResponseChange !== null ? (
                                <Tendency value={this.props.operation.maxResponseChange / 100} showValue={false} />
                            ) : null}
                        </td>
                        {this.props.compact ? null : (
                            <React.Fragment>
                                <td className="number">
                                    <LargeNumber value={this.props.operation.errors} class="error" defaultValue="0" />{' '}
                                </td>
                            </React.Fragment>
                        )}
                    </React.Fragment>
                )}

                {!this.props.operation.requests && !this.props.loading ? <td colSpan={6}>No requests in period.</td> : null}

                {this.props.loading ? (
                    <td colSpan={4} className="text-muted">
                        Loading…
                    </td>
                ) : null}

                {!this.props.sparkline || this.props.compact ? null : (
                    <td>
                        <Sparkline data={this.props.sparkline} />
                    </td>
                )}
            </tr>
        )
    }
}

export default ExternalOperation
